import React, { useState, useEffect } from 'react';
import { object, func, bool } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_TYPE, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { TableCustom, MessageModal } from '../../common';
import VariableCuentaModal from '../VariableCuentaModal';
import { CloneObject } from '../../../utils/helpers';
import { isNull } from '../../../utils/validator';
import { getDateToString, getFormatValueGrid, getFormatValueIn } from '../../../utils/convert';
import { useEntidad } from '../../hooks/useEntidad';
import { useLista } from '../../hooks/useLista';

const VariablesCuentaGrid = (props) => {

  //hooks
  const [state, setState] = useState({
      idCuenta: 0,
      idVariable: 0,
      disabled: false,
      showMessage: false,
      showForm: false,
      modeFormEdit: false,
      rowForm: null,
      list: []
  });

  const [rangoSolapado, setRangoSolapado] = useState(null);
  const [variable, setVariable] = useState({
    id: 0,
    codigo: '',
    descripcion: '',
    idTipoTributo: 0,
    tipoDato: '',
    constante: false,
    predefinido: false,
    opcional: true,
    activo: true,
    lista: ''
  });

  const dispatch = useDispatch();
  const sequenceValue = useSelector( (state) => state.sequence.value );

  const mount = () => {
    setState(prevState => {
        const list = props.data.list.filter(x => x.state !== 'r').sort((a, b) => (b.fechaDesde < a.fechaDesde) ? -1 : (b.fechaDesde < a.fechaDesde) ? 1 : 0);
        return {...prevState,
            idCuenta: props.data.idCuenta,
            idVariable: props.data.idVariable,
            list: list
        };
    });
  }
  useEffect(mount, [props.data]);

  const [, getRowEntidad, readyEntidad] = useEntidad({
    entidades: ['Variable'],
    onLoaded: (entidades, isSuccess, error) => {
      if (!isSuccess) {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: {
      key: 'Variable',
      timeout: 0
    }
  });

  useEffect(() => {
    const row = getRowEntidad('Variable', state.idVariable);
    if (row) {
      setVariable(row);
    }
  }, [state.idVariable, readyEntidad]);

  const [ , getRowLista, , getRowListaByCodigo] = useLista({
    listas: variable?.lista ? [variable?.lista] : null,
    onLoaded: (listas, isSuccess, error) => {
      if (isSuccess) {
      }
      else {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      } 
    },
    memo: {
      key: variable?.lista,
      timeout: 0
    }
  });

  const getDescLista = (codigo) => {
    const row = getRowListaByCodigo(variable?.lista, codigo);
    return (row) ? codigo + '-' + row.nombre : '';
  }

  const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (!variable.constante || state.list.length === 0) && (
                                    <div onClick={ (event) => handleClickVariableCuentaAdd() } className="link">
                                        <span className="material-symbols-outlined" title="Nuevo">add</span>
                                    </div>
                                )}
                              </div>
  const cellVMR = (data) =>  <div className='action'>
                                    <div onClick={ (event) => handleClickVariableCuentaView(data.value) } className="link">
                                    <span className="material-symbols-outlined" title="Ver">search</span>
                                    </div>
                                    {!props.disabled && (
                                    <div onClick={ (event) => handleClickVariableCuentaModify(data.value) } className="link">
                                        <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                    </div>
                                    )}
                                    {!props.disabled && (
                                    <div onClick={ (event) => handleClickVariableCuentaRemove(data.value) } className="link">
                                        <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                    </div>
                                    )}
                              </div>

  const tableColumnsVariable = [
    { Header: 'Desde', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaDesde', width: '20%' },
    { Header: 'Hasta', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaHasta', width: '20%' }
  ];
  const tableColumnsValor = [
    { Header: 'Valor', Cell: (props) => (variable.tipoDato != 'list') ? getFormatValueGrid(props.value, variable.tipoDato, true) : getDescLista(props.value), accessor: 'valor', width: '50%' },
    { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
  ];
  const tableColumns = (variable.constante) ? tableColumnsValor : tableColumnsVariable.concat(tableColumnsValor);

  //handles
  const handleClickVariableCuentaAdd = () => {
    const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
    setState(prevState => {
      const rowForm = {
        id: idTemporal,
        idVariable: state.idVariable,
        idCuenta: state.idCuenta,
        valor: '',
        fechaDesde: null,
        fechaHasta: null
      };
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    dispatch( sequenceActionNext() );
  }
  const handleClickVariableCuentaView = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
    });
  }
  const handleClickVariableCuentaModify = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
  }
  const handleClickVariableCuentaRemove = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showMessage: true, rowForm: rowForm};
    });
  }

  //funciones
  function RemoveVariableCuenta(row) {
    row.state = 'r';
    props.onChange('VariableCuenta', row);
  }

  function UpdateVariableCuenta(row) {
    row.state = isNull(state.list.find(x => x.id === row.id)) ? 'a' : 'm';
    props.onChange('VariableCuenta', row);
  }

  function ValidateVariableCuenta(row) {
    const listOthers = state.list.filter(f => f.id !== row.id);
    const conflicts = listOthers.filter(f =>
      (f.fechaDesde <= row.fechaHasta || isNull(f.fechaDesde) || isNull(row.fechaHasta)) &&
      (f.fechaHasta >= row.fechaDesde || isNull(f.fechaHasta) || isNull(row.fechaDesde))
    );
    return (conflicts.length === 0);
  }

  return (
  <>

    {state.showMessage && 
        <MessageModal
            title={"Confirmación"}
            message={"¿Está seguro de borrar el registro?"}
            onDismiss={() => {
                setState(prevState => {
                    return {...prevState, showMessage: false, rowForm: null};
                });
            }}
            onConfirm={() => {
                const row = CloneObject(state.rowForm);
                setState(prevState => {
                    return {...prevState, showMessage: false, rowForm: null};
                });
                RemoveVariableCuenta(row);
            }}
        />
    }

    {state.showForm && 
        <VariableCuentaModal
            disabled={!state.modeFormEdit}
            data={{
              entity: state.rowForm,
              definition: getRowEntidad('Variable', state.rowForm.idVariable)
            }}
            rangoSolapado={rangoSolapado}
            solapaOtroValor={!ValidateVariableCuenta(state.rowForm)}
            onDismiss={() => {
              setRangoSolapado(null);
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
            }}
            onConfirm={(row) => {
              if (ValidateVariableCuenta(row)) {
                setRangoSolapado(null);
                setState(prevState => {
                    return {...prevState, showForm: false, rowForm: null};
                });
                UpdateVariableCuenta(row);
              }
              else {
                setRangoSolapado({fechaDesde: row.fechaDesde, fechaHasta: row.fechaHasta});
              }
            }}
        />
    }

    <TableCustom
        showFilterGlobal={false}
        floatingDownloadCSVButton={true}
        className={'TableCustomBase'}
        columns={tableColumns}
        data={state.list}
    />

  </>
  );
}

VariablesCuentaGrid.propTypes = {
    disabled: bool,
    data: object.isRequired,
    onChange: func.isRequired
};

VariablesCuentaGrid.defaultProps = {
    disabled: false
  };

export default VariablesCuentaGrid;